





define(['leaflet'], function(L) {

    /**
     * @ignore
     * @param {String | HTMLElement} element Get rect from this element or query for it and then get its rects.
     * @returns {DOMRect | null} Rectangle of given element or null if something bad happens
     */
    function getRect(element) {
        try {
            if (typeof element === 'string') {
                return document.querySelector(element).getBoundingClientRect();
            }
            return element.getBoundingClientRect();
        } catch (err) {
            return null;
        }
    }

    /**
     * Helper method used to update bounding options. Used once for every control container.
     *
     * @ignore
     * @param {Object} bounds Object containing options for padding points. This object will be modified.
     * @param {Object} bounds.paddingTopLeft Object that will be passed as a top-left point of the fitBounds padding
     * @param {Number} bounds.paddingTopLeft.x Horizontal value of the top-left padding
     * @param {Number} bounds.paddingTopLeft.y Vertical value of the top-left padding
     * @param {Object} bounds.paddingBottomRight Object that will be passed as a bottom-right point of the fitBounds
     *     padding
     * @param {Number} bounds.paddingBottomRight.x Horizontal value of the bottom-right padding
     * @param {Number} bounds.paddingBottomRight.y Vertical value of the bottom-right padding
     * @param {'left' | 'right'} horizontal Parameter describing which controls are measured
     * @param {'top' | 'bottom'} vertical Parameter describing which controls are measured
     * @param {'width' | 'height' | 'both'} axis Which axis is taken into account when measuing controls
     * @param {DOMRect} rect Object containing dimensions of measured controls
     */
    function modifyBoundsForRect(bounds, horizontal, vertical, axis, rect) {
        /*__*/ if (vertical === 'top' && horizontal === 'left' && axis === 'width') {
            bounds.paddingTopLeft.x += rect[axis];
        } else if (vertical === 'top' && horizontal === 'left' && axis === 'height') {
            bounds.paddingTopLeft.y += rect[axis];
        } else if (vertical === 'top' && horizontal === 'left' && axis === 'both') {
            bounds.paddingTopLeft.x += rect.width;
            bounds.paddingTopLeft.y += rect.height;

        } else if (vertical === 'top' && horizontal === 'right' && axis === 'width') {
            bounds.paddingBottomRight.x += rect[axis];
        } else if (vertical === 'top' && horizontal === 'right' && axis === 'height') {
            bounds.paddingTopLeft.y += rect[axis];
        } else if (vertical === 'top' && horizontal === 'right' && axis === 'both') {
            bounds.paddingBottomRight.x += rect.width;
            bounds.paddingTopLeft.y += rect.height;

        } else if (vertical === 'bottom' && horizontal === 'left' && axis === 'width') {
            bounds.paddingTopLeft.x += rect[axis];
        } else if (vertical === 'bottom' && horizontal === 'left' && axis === 'height') {
            bounds.paddingBottomRight.y += rect[axis];
        } else if (vertical === 'bottom' && horizontal === 'left' && axis === 'both') {
            bounds.paddingTopLeft.x += rect.width;
            bounds.paddingBottomRight.y += rect.height;

        } else if (vertical === 'bottom' && horizontal === 'right' && axis === 'width') {
            bounds.paddingBottomRight.x += rect[axis];
        } else if (vertical === 'bottom' && horizontal === 'right' && axis === 'height') {
            bounds.paddingBottomRight.y += rect[axis];
        } else if (vertical === 'bottom' && horizontal === 'right' && axis === 'both') {
            bounds.paddingBottomRight.x += rect.width;
            bounds.paddingBottomRight.y += rect.height;
        }
    }

    
    function modifyBoundsOptions(fitBoundsOptions, controls, position) {
        var topOrBottom, leftOrRight, direction, selector, rect;
        var split = position.split('-');
        if (!(split && split.length === 2)) {
            return;
        }
        topOrBottom = split[0];
        leftOrRight = split[1];
        direction = controls[position]; // width or height or both

        selector = '.leaflet-' + topOrBottom + '.leaflet-' + leftOrRight;
        rect = getRect(selector);
        if (!rect) {
            return;
        }

        modifyBoundsForRect(fitBoundsOptions, leftOrRight, topOrBottom, direction, rect);
    }

    /**
     * @class MapUtils
     * @extends L
     * @module Map
     * @namespace L
     */
    L.MapUtils = {
        /**
         * This method looks over all layers in the map instance and returns an array
         * of matching layers. If layers are not found, returns empty array.
         * @method findLayersByName
         * @param {String} layerName Name of the layers you are looking for
         * @param {Map} map Map instance
         * @returns {Array} Returns an array of matching layers, if no element was found,
         * returns empty array.
         */
        findLayersByName: function(layerName, map) {
            var matchingLayers = [];
            map.eachLayer(function(layer) {
                if (layer.name === layerName) {
                    matchingLayers.push(layer);
                }
            });
            return matchingLayers;
        },

        /**
         * @method getPaddingOptions
         * @example
         * ```javascript
         * var popup = marker.openPopup().getPopup();
         * var popupElement = popup.getElement();
         * var bounds = L.MapUtils.getPaddingOptions({
         *      popup: popupElement,
         *      controls: {
         *          'top-left': 'width', // only width will be taken into account
         *          'bottom-right': 'both'
         *      }
         * });
         * ```
         * @param {Object} components Object describing how paddings should be calculated
         * @param {HTMLElement} [components.popup] Popup element which dimensions will be calculated
         * @param {Object} [components.controls] Object which values describes which control panel is measured and how.
         *      possible keys are `'top-left'`, `'top-right'`, `'bottom-left'`, `'bottom-right'` and values:
         *      `'width'`, `'height'`, `'both'`.
         * @returns {Object} Returns an object reflecting measurements on control containers
         */
        getPaddingOptions: function(components) {
            var popupRect;
            var controls = components.controls;
            var popup = components.popup;
            var fitBoundsOptions = {
                paddingTopLeft: { x: 0, y: 0 },
                paddingBottomRight: { x: 0, y: 0 }
            };
            if (controls) {
                try {
                    Object.getOwnPropertyNames(controls)
                        .forEach(modifyBoundsOptions.bind(null, fitBoundsOptions, controls));
                } catch (err) {
                    //
                }
            }
            if (popup) {
                try {
                    popupRect = getRect(popup);
                    fitBoundsOptions.paddingTopLeft.x += popupRect.width / 2;
                    fitBoundsOptions.paddingBottomRight.x += popupRect.width / 2;
                    fitBoundsOptions.paddingTopLeft.y += popupRect.height;
                } catch (err) {
                    //
                }
            }
            return fitBoundsOptions;
        },

        /**
         * @method setViewWithOffset
         * @param {Map} map Map object that is associated with setView method
         * @param {LatLng} targetLatLng Point that is the original center of the transformation
         * @param {number} targetZoom Zoom level that is going to be applied to setView
         * @param {Object} options Pan and zoom options
         * @param {Point} offsetPoint Point that represents the shift of the original center point
         */
        setViewWithOffset: function(map, targetLatLng, targetZoom, options, offsetPoint) {
            var targetPoint = map.project(targetLatLng, targetZoom).subtract(offsetPoint);
            var offsetLatLng = map.unproject(targetPoint, targetZoom);
            map.setView(offsetLatLng, targetZoom, options);
        }

    };

    return L.MapUtils;
});



// WEBPACK FOOTER //
// ./display/mapUtils.js